import React from "react";
import { Accordion } from "react-bootstrap";
import styles from "./index.module.scss";
import { AssetStore } from "../../assets/AssetsStore";
import Assets from "../Layout/Assets";

function DashboardNavbar({
  onItemClick,
  activeNavItem,
  navData,
  theme,
  isDoctor,
}) {
  const getIconStyle = () => {
    return {
      color: theme?.secondary,
    };
  };

  const getActiveListItemStyle = () => {
    return {
      backgroundColor: "#314f7c",
      color: "#fff",
    };
  };

  const getNavBarStyle = () => {
    return {
      backgroundColor: theme?.primary,
      color: "#fff",
    };
  };
  const userData = JSON.parse(localStorage.getItem("userData"));

  return (
    <div className={styles.container} style={getNavBarStyle()}>
      <div className={styles.navBarHeader}>
        <div className={styles.navBarProfileWrap}>
          <div className={styles.navBarProfile}>
            <h5>{userData?.profileName}</h5>
            <span>{userData?.mobileNumber}</span>
          </div>
          <span className={styles.caption}>
            {isDoctor
              ? userData?.specialityName != ""
                ? userData?.specialityName
                : ""
              : "Patient ID :" + userData?.profileId}
          </span>
        </div>

        <Accordion
          defaultActiveKey={[1]}
          className={styles.side_nav_accordion_interbranch}
        >
          {navData &&
            navData.length &&
            navData.map((object, menuKey) => {
              if (object?.tittle) {
                return (
                  <Accordion.Item key={menuKey} eventKey={menuKey}>
                    <Accordion.Header>
                      <div className={styles.list_tittle}>{object.tittle}</div>
                    </Accordion.Header>

                    {object.options.map((element, optionKey) => {
                      return (
                        <Accordion.Body
                          onClick={() => {
                            element.isContact ?? onItemClick(element.name);
                          }}
                          style={
                            activeNavItem === element?.name
                              ? getActiveListItemStyle()
                              : {}
                          }
                          key={optionKey}
                        >
                          <div className="icon" style={getIconStyle()}>
                            {element?.isContact ? (
                              <img src={element.ico} alt="ico" />
                            ) : (
                              element.ico
                            )}
                          </div>
                          <div className={styles.itemName}>
                            {element?.isContact ? (
                              <a href={element?.href}>{element.name}</a>
                            ) : (
                              element.name
                            )}
                          </div>
                        </Accordion.Body>
                      );
                    })}
                  </Accordion.Item>
                );
              } else {
                return (
                  <>
                    {object.options.map((element, optionKey) => {
                      if (element?.name !== "Prescription") {
                        return (
                          <button
                            key={`selarated_${optionKey}`}
                            onClick={() => {
                              onItemClick(element.name);
                            }}
                            style={
                              activeNavItem === element?.name
                                ? getActiveListItemStyle()
                                : {}
                            }
                            className={`${styles.separated_nav_button}`}
                          >
                            <div className="icon" style={getIconStyle()}>
                              {element.ico}
                            </div>
                            <div className="text">{element?.name}</div>
                          </button>
                        );
                      }
                    })}
                  </>
                );
              }
            })}
        </Accordion>
      </div>

    </div>
  );
}

export default DashboardNavbar;
